"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _customPage = require("@/api/customPage");
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'BottomShopList',
  props: ['itemDetail'],
  data: function data() {
    return {
      bottomShopList: {}
    };
  },
  mounted: function mounted() {
    var _this = this;
    (0, _customPage.moduleDetail)({
      moduleId: this.itemDetail.moduleId
    }).then(function (res) {
      console.log('------------------------------', res);
      _this.bottomShopList = res.data.bottomShopList;
    });
  }
};